<template>
  <div class="mul-devices">
    <el-row>
      <el-col :span="6">
        <el-select v-model="selectVal" multiple collapse-tags filterable style="width: 100%">
          <el-option v-for="item in bmDevices" :key="item.sn" :label="item.name" :value="item.sn">
            <span style="float: left; font-size: 13px">{{ item.name }}</span>
            <span style="float: left; color: #8492a6; font-size: 12px; margin: 0 5px">
              {{ item.sn }}
            </span>
            <LineState style="float: right; margin-right: 20px" :state="item.state" />
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row class="module-box" :gutter="20">
      <el-col v-for="v in selectedBioModules" :key="v.sn" :span="8">
        <BM4000Module :deviceInfo="v" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import Type from '@/store/mutation-type';
import BM4000Module from './components/bm4000-module';
import LineState from '@/components/line-state';

export default {
  name: 'MulDevices',
  props: {
    deviceType: String
  },
  sockets: {
    '/socket/detail'(res) {
      this.$set(this.deviceDetail, 'newVal', res);
    }
  },
  data() {
    return {
      deviceDetail: {}
    };
  },
  provide() {
    return {
      deviceDetail: this.deviceDetail
    };
  },
  components: {
    BM4000Module,
    LineState
  },
  computed: {
    ...mapState('socket', ['webSocket', 'devicesSourseMap']),
    ...mapState('app', ['mulDevicesSelected']),
    selectVal: {
      get() {
        return this.mulDevicesSelected;
      },
      set(newVal) {
        if (newVal.length > 3) {
          this.$message({
            type: 'warning',
            message: '只能选择三台设备,请自行删除',
            showClose: true
          });
        } else {
          this.saveMulDevices({ deivces: this.bmDevices, selected: newVal });
          this.subDetail();
        }
      }
    },
    bmDevices() {
      return this.devicesSourseMap.filter(e => e.deviceType === this.deviceType);
    },
    selectedBioModules() {
      return this.bmDevices
        ? this.bmDevices.filter(item => {
            return this.selectVal.indexOf(item.sn) > -1;
          })
        : [];
    }
  },
  methods: {
    ...mapActions('mqtt', ['subDeviceDetail', 'unsubDeviceDetail']),

    ...mapMutations('app', {
      saveMulDevices: Type.SAVE_MUL_DEVICES
    }),
    subDetail() {
      this.subDeviceDetail({ sn: this.selectVal });
    },
    unsubDetail() {
      this.unsubDeviceDetail({ sn: this.selectVal });
    }
  },
  created() {
    this.saveMulDevices({ deivces: this.bmDevices });
    this.subDetail();
  },
  beforeDestroy() {
    this.unsubDetail();
  }
};
</script>

<style lang="scss">
.mul-devices {
  height: 100%;
  .module-box {
    height: calc(100% - 50px);
    margin-top: 10px;
    .el-col {
      height: 100%;
    }
  }
}
</style>
